var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-circular',{class:_vm.classes,attrs:{"size":_vm.size,"width":_vm.width,"value":_vm.progress,"indeterminate":!_vm.progress,"color":"primary"}},[_vm._v(_vm._s(_vm.progress))])}
var staticRenderFns = []

export { render, staticRenderFns }